// takes a state select dropdown and adds an onChange event
// to navigate to state URIs (e.g. '/ut')

const init = () => {
    $('.state-select').on('change', (e) => {
        window.location.href = `${
            e.currentTarget[e.currentTarget.selectedIndex].value
        }`;
    });
};

export { init };
